import Hero from "../components/hero";
import { DownloadResourcesPage } from "@features/general";
import heroImage from "@assets/images/downloads-hero.svg";

const heroData = {
  title: "Access All GAZ Documents in One Place",
  description:
    "Download forms, safety guides, tariffs, certificates, and official policies directly from our resource library. All documents are regularly updated and fully compliant with UAE regulations.",
  image: heroImage,
  buttonText: "Search",
  buttonInput: true,
  buttonInputPlaceholder: "Search for documents",
};

function DownloadsResourcesLibrary() {
  return <DownloadResourcesPage hero={<Hero data={heroData} />} />;
}

export default DownloadsResourcesLibrary;
